// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// NgRx actions
import { setCustomPDFReportBuilderStore } from '../custom-pdf-report-builder/custom-pdf-report-builder.action';
import { setReportType } from './report-type.action';
export const report_type = createReducer(null, on(setCustomPDFReportBuilderStore, setReportType, (state, action) => {
    return action.report_type;
}));
